import {
  getLocalStorageItem,
  removeLocalStorageItem,
} from '@/utils/local-storage/safe-local-storage';

export const readLocalStorage = (key: string) => {
  const storageValue = getLocalStorageItem(key);
  if (!storageValue) {
    return null;
  }
  try {
    return JSON.parse(storageValue);
  } catch {
    removeLocalStorageItem(key);
    return null;
  }
};
